var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7ee67c60ff1a00bdc40679538938c741e72052ed"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["rstanger@jake-stanger"]={id:"7ee67c60ff1a00bdc40679538938c741e72052ed"};
      